import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedCustomerAttachedImagesQueryParamsType,
  GetDamagedCustomerAttachedImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerAttachedImages/getDamagedCustomerAttachedImagesQuery.type';

export const getDamagedCustomerAttachedImagesFunction = (
  params: GetDamagedCustomerAttachedImagesQueryParamsType,
): Promise<GetDamagedCustomerAttachedImagesQueryResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/customer/images/additional/vehicle/`,
    { params: { damaged_id: params.damaged_id } },
  );
};
